"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextComponent = void 0;
var TextComponent;
(function (TextComponent) {
    TextComponent.type = 'text';
    TextComponent.backgroundColors = [
        'none',
        'white',
        'black',
        'yellow',
        'pink',
        'blue',
        'green',
        'red',
        'orange',
        'cyan',
    ];
})(TextComponent || (exports.TextComponent = TextComponent = {}));
//# sourceMappingURL=TextComponent.js.map